<script>
import LikeAction from './LikeAction.vue';
import CommentCta from './Comments/CommentCta';
import collapsible from '../mixins/collapsible';

export default {
    name: 'ArticleSidebar',
    components: {
        LikeAction,
        CommentCta,
    },
    mixins: [collapsible],
};
</script>
